// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: userCrud.js
// Description: This file is responsible for All API call for user
//
// ************************************************************************************************************************************************************
import API from "../../../config/networkInterceptor";

export function addUser(values, countryCode, locationId) {
  return API.post("v1/users", {
    firstName: values.fname,
    lastName: values.lname,
    email: values.email,
    countryCode: countryCode,
    phoneNumber: values.phone,
    location: locationId   
  });
}

export function editUser(values, countryCode, locationId, id) {
  let _id = id.toString();
  return API.put("v1/users/" + _id, {
    firstName: values.fname,
    lastName: values.lname,
    countryCode: countryCode,
    phoneNumber: values.phone,
    location: locationId   
  });
}
/*
==================================================================================
Created On : 17/10/2023
Purpose: Inactive User API Implementation 
==================================================================================
*/
export function getInactiveUsers(count, page, sort_column, sort_order) {
  return API.get(
    "v1/users/InActive?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order
  );
}
export function getUser({ count, page, sort_column, sort_order, user_menu }) {
  return API.get(
    "v1/users?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order +
      "&user_menu=" +
      user_menu
  );
}
/*
==================================================================================
Created On : 25/10/2023
Purpose: Count API Implementation for User count
==================================================================================
*/
export function getUsersCount(menutype) {
  return API.get("v1/users/menu/count/" + menutype);
}

/*
==================================================================================
Created On : 9/11/2023
Purpose: Search Users API Implementation
==================================================================================
*/
export function searchUsers({
  searchValue,
  facilityId,
  count,
  page,
  sort_column,
  sort_order
}) {
  return API.post(
    "v1/users/search?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order,
    {
      searchValue: searchValue,
      facilityId: facilityId
    }
  );
}
export function getUserDetailsById(id) {
  return API.get("v1/users/" + id);
}
export function resetUser(id) {
  return API.put("v1/users/" + id + "/reset");
}
export function getUserforFacility(
  facility_id,
  count,
  page,
  sort_column,
  sort_order
) {
  /*
==================================================================================
Created On : 01/01/2024
Purpose: delete API Implementation for User
==================================================================================
*/
  return API.get(
    "v1/facilities/" +
      facility_id +
      "/users?count=" +
      count +
      "&page=" +
      page +
      "&sort_column=" +
      sort_column +
      "&sort_order=" +
      sort_order
  );
}

export function deleteUser(
  user_menu,
  facility_id,
  forceDelete,
  user_ids,
  skippeduser_ids
) {
  return API.delete(`v1/users/multiple/delete`, {
    data: {
      user_menu: user_menu,
      facility_id: facility_id,
      forceDelete: forceDelete,
      user_ids: user_ids,
      skippeduser_ids: skippeduser_ids
    }
  });
}
export function deleteSearchUser(
  user_menu,
  facility_id,
  forceDelete,
  searchValue,
  user_ids,
  skippeduser_ids
) {
  return API.delete(`v1/users/multiple/delete/search`, {
    data: {
      user_menu: user_menu,
      facility_id: facility_id,
      forceDelete: forceDelete,
      searchValue: searchValue,
      user_ids: user_ids,
      skippeduser_ids: skippeduser_ids
    }
  });
}
